import { render, staticRenderFns } from "./eventsDetail.vue?vue&type=template&id=13a80d1a&scoped=true"
import script from "./eventsDetail.vue?vue&type=script&lang=js"
export * from "./eventsDetail.vue?vue&type=script&lang=js"
import style0 from "./eventsDetail.vue?vue&type=style&index=0&id=13a80d1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a80d1a",
  null
  
)

export default component.exports